import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function conditionalRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && control.value.trim().length > 0) {
      return control.value ? { required: true } : null;
    }
    return null;
  };
}
